import StreamEvents from '@classes/StreamEvents/StreamEvents';
import { Box, Skeleton, Typography } from '@mui/material';
import { IStoreState } from '@store/index';
import Utils from '@utils/index';
import { first } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';

const ConfirmationText: React.FC<{ event?: VideoStreamEvent }> = (props) => {
  const { event } = props;

  const companies = useSelector((store: IStoreState) => store.companies.companies);
  const sites = useSelector((store: IStoreState) => store.sites.sites)
  const eventHistory = useSelector((store: IStoreState) => store.overviewView.eventHistory);
  const loading = useSelector((store: IStoreState) => store.overviewView.loadingEventHistory);

  const text = React.useMemo(() => {
    if (event) {
      const history = first(eventHistory);
      const timezone = StreamEvents.getCompanyAndSite(event, companies, sites).site?.timezone?.split(' ')[0];
      return <Typography>Are you sure you want to remove tag <b>{Utils.StreamEvent.getTagText(first(event?.tags) || "")}</b> added by <b>{history?.author?.isCurrentUser ? "You" : history?.author?.name || ""}</b> on <b>{Utils.Date.format(new Date(history?.ts || 0), 'MMM Do, YYYY hh:mm:ss A', timezone)}</b>?</Typography>
    }

    return <Typography>Are you sure you want to remove the current tag from the events?</Typography>
  }, [companies, event, eventHistory, sites])

  if (!event) return null;

  if (loading) return (
    <Box display="flex" flexDirection="column" justifyContent="center" width="100%">
      <Skeleton variant="text" sx={{ fontSize: '1rem' }} width="100%" />
      <Skeleton variant="text" sx={{ fontSize: '1rem' }} width="80%" />
    </Box>
  )

  return (
    text
  )
}

export default ConfirmationText;
